import BaseService from '../../base/base_service';
import DOM from '../../utils/dom';
import Event from '../../utils/event';
import {SYSTEM_EVENTS} from '../../events/events';

export default class VisibilityDetectorService extends BaseService {
    static CLASS = 'VisibilityDetectorService';

    init(params) {
        super.init(params);
        this.start();
    }

    start() {
        this.logger.debug('Start visibility detector service.');
        DOM.addEventListener(window.document, 'visibilitychange', this.onVisibilityChange);
    }

    /**
     * Listener for the visibilitychange event
     */
    private onVisibilityChange = () => {
        if (this.isActive()) {
            Event.fire(SYSTEM_EVENTS.APP_RESUMED);
        } else {
            Event.fire(SYSTEM_EVENTS.APP_PAUSED);
        }
        return this;
    }

    /**
     * check if current tab is active
     */
    isActive() {
        if (!window.document.visibilityState) {
            return true;
        }
        return window.document.visibilityState === "visible";
    }

}
